var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08301 3.33594H4.99967C4.55765 3.33594 4.13372 3.51153 3.82116 3.82409C3.5086 4.13665 3.33301 4.56058 3.33301 5.0026V16.6693C3.33301 17.1113 3.5086 17.5352 3.82116 17.8478C4.13372 18.1603 4.55765 18.3359 4.99967 18.3359H9.99967M12.9163 3.33594H14.9997C15.4417 3.33594 15.8656 3.51153 16.1782 3.82409C16.4907 4.13665 16.6663 4.56058 16.6663 5.0026V12.5026",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 5.33594V3.7526C6.6665 3.6421 6.7104 3.53612 6.78854 3.45798C6.86668 3.37984 6.97266 3.33594 7.08317 3.33594C7.31317 3.33594 7.50317 3.14927 7.54317 2.9226C7.6665 2.2126 8.14484 0.835938 9.99984 0.835938C11.8548 0.835938 12.3332 2.2126 12.4565 2.9226C12.4965 3.14927 12.6865 3.33594 12.9165 3.33594C13.027 3.33594 13.133 3.37984 13.2111 3.45798C13.2893 3.53612 13.3332 3.6421 13.3332 3.7526V5.33594C13.3332 5.46855 13.2805 5.59572 13.1867 5.68949C13.093 5.78326 12.9658 5.83594 12.8332 5.83594H7.1665C7.0339 5.83594 6.90672 5.78326 6.81295 5.68949C6.71918 5.59572 6.6665 5.46855 6.6665 5.33594V5.33594Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9165 17.0859L14.5832 18.7526L18.7498 14.5859",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardDarkMode);
export default __webpack_public_path__ + "static/media/clipboardDarkMode.a5cb7e1923dcf61b62641f0fb1ed4a18.svg";
export { ForwardRef as ReactComponent };